<style>
.splitselect {
    width: 130px;
    float: left;
}
.search-split .ivu-radio-wrapper {
    padding-left: 0px !important;
}
.search-split .ivu-tooltip-inner {
    width: 200px;
    white-space: normal;
}
</style>
<template>
    <div>
        <compWrapper
            theme="primary"
            :title="$t('erp.ordersplit.split', { defaultValue: '订单拆分' })"
        >
            <Alert type="warning" class="margin-10">{{
                $t("erp.ordersplit.alert", {
                    defaultValue:
                        "开启后，可设置条件对订单进行自动拆分。条件不勾选默认所有订单拆分为一单一件，勾选后可根据订单是否包含原包装产品或指定发运方式进行拆分。",
                })
            }}</Alert>
            <vForm class="search-split" :label-width="130" inline ref="form">
                <vFormItem
                    :label="
                        $t('erp.ordersplit.opensplit', {
                            defaultValue: '启用订单拆分',
                        })
                    "
                    style="width: 50%"
                >
                    <vCheckbox
                        :trueValue="1"
                        :falseValue="0"
                        v-model="formData1.status"
                    ></vCheckbox>
                    <div v-if="formData1.status == 1">
                        <Checkbox
                            trueValue="1"
                            falseValue="0"
                            v-model="formData1.isOriginal.status"
                        >
                            <span class="font-12"
                                >{{
                                    $t("erp.ordersplit.isOriginaltiptitle", {
                                        defaultValue: "原包装订单拆分",
                                    })
                                }}
                                <Tooltip
                                    max-width="300"
                                    :content="
                                        $t('erp.ordersplit.isOriginaltip', {
                                            defaultValue: '原包装订单拆分',
                                        })
                                    "
                                    placement="top"
                                >
                                    <Icon
                                        class="font-14"
                                        type="md-help-circle"
                                    />
                                </Tooltip>
                            </span>
                        </Checkbox>
                        <Checkbox
                            class="margin-left-10"
                            trueValue="1"
                            falseValue="0"
                            v-model="formData1.carrierService.status"
                            @on-change="changeStatus"
                        >
                            <span class="font-12"
                                >{{
                                    $t(
                                        "erp.ordersplit.carrierServicetiptitle",
                                        { defaultValue: "指定发运方式拆分" }
                                    )
                                }}
                                <Tooltip
                                    max-width="300"
                                    :content="
                                        $t('erp.ordersplit.carrierServicetip', {
                                            defaultValue: '指定发运方式拆分',
                                        })
                                    "
                                    placement="top"
                                >
                                    <Icon
                                        class="font-14"
                                        type="md-help-circle"
                                    />
                                </Tooltip>
                            </span>
                        </Checkbox>
                    </div>
                    <div
                        style="margin-left: 141px; display: flex"
                        v-if="showCarrierStatus && formData1.status == 1"
                    >
                        <Select
                            :placeholder="
                                $t('global.common.choose', {
                                    defaultValue: '请选择条件',
                                })
                            "
                            class="splitselect"
                            v-model="formData1.carrierService.connectionRule"
                        >
                            <Option value="==">{{
                                $t("erp.ordersplit.equal", {
                                    defaultValue: "等于",
                                })
                            }}</Option>
                            <Option value="!=">{{
                                $t("erp.ordersplit.unequal", {
                                    defaultValue: "不等于",
                                })
                            }}</Option>
                        </Select>
                        <!-- <vSelect :placeholder="$t('global.common.choose', { defaultValue: '请选择条件' })" class="pull-left width-50per" v-model="formData1.carrierService.attrbuteValue" filterable multiple clearable>
                            <vOption v-for="(item,index) in carrierServiceList" :key="index" :value="item.value">{{item.label}}</vOption>
                        </vSelect> -->

                        <compMultipleSelect
                            :nclass="'width-100per'"
                            :options="carrierServiceList"
                            :modelValue="formData1.carrierService.attrbuteValue"
                            :placeholder="
                                $t('global.common.choose', {
                                    defaultValue: '请选择',
                                })
                            "
                            :vstyle="'max-width:400px'"
                            @update:modelValue="changeShip"
                        >
                        </compMultipleSelect>
                    </div>
                </vFormItem>
            </vForm>
        </compWrapper>
        <compWrapper
            theme="info"
            :title="
                $t('erp.ordersplit.calculate', { defaultValue: '运费测算' })
            "
        >
            <Alert type="warning" class="margin-10">{{
                $t("erp.ordersplit.calculatealert", {
                    defaultValue:
                        "开启后，可测算订单物流费用，默认按自定义费率测算费用，也可按物流官方费率测算费用。",
                })
            }}</Alert>
            <vForm class="search-split" :label-width="130" inline ref="form">
                <vFormItem
                    :label="
                        $t('erp.ordersplit.opencalculate', {
                            defaultValue: '启用运费测算',
                        })
                    "
                >
                    <vCheckbox
                        :trueValue="1"
                        :falseValue="0"
                        v-model="formData2.status"
                    ></vCheckbox>
                    <div v-if="formData2.status == 1">
                        <RadioGroup
                            v-model="formData2.calculateType.attrbuteValue"
                        >
                            <Radio label="2" disabled>
                                <span class="font-12"
                                    >{{
                                        $t(
                                            "erp.ordersplit.calculateTypeonetitle",
                                            { defaultValue: "物流官方费率测算" }
                                        )
                                    }}
                                    <Tooltip
                                        width="300"
                                        :content="
                                            $t(
                                                'erp.ordersplit.calculateTypeone',
                                                {
                                                    defaultValue:
                                                        '物流官方费率测算',
                                                }
                                            )
                                        "
                                        placement="top"
                                    >
                                        <Icon
                                            class="font-14"
                                            type="md-help-circle"
                                    /></Tooltip>
                                </span>
                            </Radio>
                            <Radio label="1">
                                <span class="font-12"
                                    >{{
                                        $t(
                                            "erp.ordersplit.calculateTypetwotitle",
                                            { defaultValue: "自定义费率测算" }
                                        )
                                    }}
                                </span>
                                <Tooltip
                                    class="max300"
                                    :content="
                                        $t('erp.ordersplit.calculateTypetwo', {
                                            defaultValue: '自定义费率测算',
                                        })
                                    "
                                    placement="top"
                                >
                                    <Icon
                                        class="font-14"
                                        type="md-help-circle"
                                    />
                                </Tooltip>
                            </Radio>
                        </RadioGroup>
                    </div>
                </vFormItem>
            </vForm>
        </compWrapper>
        <compWrapper
            theme="gray"
            :title="
                $t('erp.aftersales.buyfaceorder', { defaultValue: '购买面单' })
            "
        >
            <Alert type="warning" class="margin-10">{{
                $t("erp.ordersplit.purchaorderalert", {
                    defaultValue:
                        "开启后，可购买面单，卡车发货方式默认不能购买面单。",
                })
            }}</Alert>
            <vForm class="search-split" :label-width="130" inline ref="form">
                <vFormItem
                    :label="
                        $t('erp.ordersplit.openbuyfaceorder', {
                            defaultValue: '启用购买面单',
                        })
                    "
                >
                    <vCheckbox
                        :trueValue="1"
                        :falseValue="0"
                        v-model="formData3.status"
                    ></vCheckbox>
                </vFormItem>
            </vForm>

            <div v-if="ordersplitset" class="text-right margin-right-20">
                <vButton theme="primary" @click="submit">{{
                    $t("global.common.save", { defaultValue: "保存" })
                }}</vButton>
            </div>
        </compWrapper>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import {
    HttpGetOrderSplit,
    HttSaveOrderSplit,
    HttpActiveGetService,
    HttpGetAllCustomerIdCode,
} from "@/service/boss/b2corder";
export default {
    data() {
        return {
            formData1: {
                isOriginal: {},
                carrierService: {
                    attrbuteValue: [],
                },
            },
            formData2: {
                calculateType: {},
            },
            formData3: {},
            serviceCodeList: [],
            carrierServiceList: [],
            showCarrierStatus: false,
        };
    },
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("@components/templates/log"),
    },
    created() {
        this.ordersplitset = this.handleAuth("erp.orderconf.set");
        this.getDetail();
    },
    computed: {
        // ...mapGetters('dictionary',['getCarrierServiceList']),
    },
    methods: {
        // 切换发货方式
        changeShip(val) {
            this.formData1.carrierService.attrbuteValue = val;
        },
        changeStatus() {
            this.showCarrierStatus = !this.showCarrierStatus;
        },
        getDetail() {
            console.log(11111111111122222);
            HttpGetAllCustomerIdCode().then(
                (res) => {
                    this.carrierServiceList = res.data.map((res) => {
                        return {
                            value: res.code,
                            label: `${res.code}(${res.carrierServiceName})`,
                        };
                    });
                },
                (err) => {}
            );
            HttpGetOrderSplit().then(
                (res) => {
                    this.formData1 = res.data[0];
                    this.formData1.isOriginal = JSON.parse(
                        res.data[0].additionalRuleData
                    )[0];
                    this.formData1.carrierService = JSON.parse(
                        res.data[0].additionalRuleData
                    )[1];
                    console.log(JSON.parse(res.data[0].additionalRuleData)[1]);
                    if (
                        JSON.parse(res.data[0].additionalRuleData)[1]
                            .attrbuteValue
                    ) {
                        this.formData1.carrierService.attrbuteValue =
                            JSON.parse(
                                res.data[0].additionalRuleData
                            )[1].attrbuteValue.split(",");
                        console.log(
                            this.formData1.carrierService.attrbuteValue
                        );
                    }
                    if (this.formData1.carrierService.status == 1) {
                        this.showCarrierStatus = true;
                    }
                    // console.log(this.formData1)
                    this.formData2 = res.data[1];
                    this.formData2.calculateType = JSON.parse(
                        res.data[1].additionalRuleData
                    )[0];

                    this.formData3 = res.data[2];
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
        submit() {
            this.formData1.isOriginal.attrbuteValue =
                this.formData1.isOriginal.status;
            if (
                this.formData1.carrierService.status == 1 &&
                this.formData1.carrierService.attrbuteValue.length < 1
            ) {
                this.$VMessage.error(
                    this.$t("erp.ordersplit.typenull", {
                        defaultValue: "发运方式不能为空！",
                    })
                );
                return;
            }
            this.formData1.carrierService.attrbuteValue =
                this.formData1.carrierService.attrbuteValue.join(",");
            let arr1 = [];
            arr1.push(this.formData1.isOriginal, this.formData1.carrierService);
            this.formData1.additionalRuleData = JSON.stringify(arr1);

            let arr2 = [];
            arr2.push(this.formData2.calculateType);
            this.formData2.additionalRuleData = JSON.stringify(arr2);

            // console.log(this.formData1,'11111')
            // console.log(this.formData2,'22222')
            // console.log(this.formData3,'33333')
            let allarr = [];
            allarr.push(this.formData1, this.formData2, this.formData3);
            HttSaveOrderSplit({
                saleOrderConfEntities: allarr,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    // 重新请求
                    this.getDetail();
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
    },
};
</script>
